module.exports = __webpack_public_path__ + "static/img/maro.888e0658.png";